import { render, staticRenderFns } from "./PortalRuleset.vue?vue&type=template&id=fc6eb5fa&scoped=true&"
import script from "./PortalRuleset.vue?vue&type=script&lang=js&"
export * from "./PortalRuleset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6eb5fa",
  null
  
)

export default component.exports